module.exports = __webpack_public_path__ + "img/down-nx1.867f6dc7.jpg";